import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
	selector: '[appSelectFirstInput]form'
})
export class SelectFirstInputDirective implements AfterViewInit {

	constructor(public eRef: ElementRef) {
	}

	public getInputElement(nativeElement: any): any {
		if (!nativeElement || !nativeElement.children) {
			return undefined;
		}
		if (!nativeElement.children.length && nativeElement.localName === 'input' && !nativeElement.hidden) {
			return nativeElement;
		}

		let input;

		[].slice.call(nativeElement.children).every(c => {
			input = this.getInputElement(c);
			if (input) {
				return false;
			} // break
			return true; // continue!
		});

		return input;
	}

	ngAfterViewInit() {
		const formChildren = [].slice.call(this.eRef.nativeElement.children);

		formChildren.every(child => {
			const input = this.getInputElement(child);

			if (input) {
				setTimeout(() => {
					input.focus();
				}, 500);
				return false; // break!
			}

			return true; // continue!
		});
	}
}
